'use strict';

angular
  .module('appSettingTransportation')
  .component('appSettingTransportation', {
    template: require('./transportation.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService',
      function AppSettingTransportationController($rootScope, $resource, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'appSetting';
        $rootScope.menu = 'transportation';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.canEditAppSettings();
        this.fees = { TH: 40, KR: 0, JP: 0 };
        this.instantFees = { TH: 50, KR: 0, JP: 0 };
        this.saving = false;

        this._normalizeFee = (value) => {
          const n = Number(value);
          if (!Number.isFinite(n) || n < 0) return 0;
          return Math.round(n * 100) / 100;
        };

        this._applyFees = (transportation, instant) => {
          const t = transportation || {};
          const i = instant || {};
          this.fees = {
            TH: this._normalizeFee(t.TH != null ? t.TH : 40),
            KR: this._normalizeFee(t.KR != null ? t.KR : 0),
            JP: this._normalizeFee(t.JP != null ? t.JP : 0),
          };
          this.instantFees = {
            TH: this._normalizeFee(i.TH != null ? i.TH : 50),
            KR: this._normalizeFee(i.KR != null ? i.KR : 0),
            JP: this._normalizeFee(i.JP != null ? i.JP : 0),
          };
        };

        this.load = () => {
          $resource(`${APIURL}/admin/services/apps/settings`)
            .get()
            .$promise
            .then((data) => {
              this._applyFees(
                data && data.transportation_fee,
                data && data.instant_wash_fee
              );
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.save = () => {
          if (!this.isLevel2Auth) {
            return;
          }
          if (!confirm($translate.instant('교통비를 저장하시겠습니까?'))) {
            return;
          }
          this.saving = true;
          const payload = {
            transportation_fee: {
              TH: this._normalizeFee(this.fees.TH),
              KR: this._normalizeFee(this.fees.KR),
              JP: this._normalizeFee(this.fees.JP),
            },
            instant_wash_fee: {
              TH: this._normalizeFee(this.instantFees.TH),
              KR: this._normalizeFee(this.instantFees.KR),
              JP: this._normalizeFee(this.instantFees.JP),
            },
          };
          const Res = $resource(`${APIURL}/admin/services/apps/settings`, {}, {
            update: { method: 'PUT' },
          });
          Res.update(payload)
            .$promise
            .then((data) => {
              this._applyFees(
                (data && data.transportation_fee) || payload.transportation_fee,
                (data && data.instant_wash_fee) || payload.instant_wash_fee
              );
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            })
            .finally(() => {
              this.saving = false;
            });
        };

        this.load();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/app-setting/transportation/transportation.component.js